import { FC } from 'react';

interface ReportMetricComparisonCaptionProps {
  caption?: string;
}

const ReportMetricComparisonCaption: FC<ReportMetricComparisonCaptionProps> = ({
  caption,
}) => {
  if (!caption) {
    return null;
  }

  return (
    <p
      data-cy="report-metric-comparison-caption"
      className="tw-font-light tw-text-sm tw-text-grayscale-100"
    >
      {caption}
    </p>
  );
};

export default ReportMetricComparisonCaption;
